"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particles = void 0;

var Links_1 = require("./Links/Links");

var Move_1 = require("./Move/Move");

var ParticlesNumber_1 = require("./Number/ParticlesNumber");

var Opacity_1 = require("./Opacity/Opacity");

var Shape_1 = require("./Shape/Shape");

var Size_1 = require("./Size/Size");

var Rotate_1 = require("./Rotate/Rotate");

var Shadow_1 = require("./Shadow");

var Stroke_1 = require("./Stroke");

var Collisions_1 = require("./Collisions");

var Twinkle_1 = require("./Twinkle/Twinkle");

var AnimatableColor_1 = require("./AnimatableColor");

var Life_1 = require("./Life/Life");

var Bounce_1 = require("./Bounce/Bounce");

var Particles = /*#__PURE__*/function () {
  function Particles() {
    _classCallCheck(this, Particles);

    this.bounce = new Bounce_1.Bounce();
    this.collisions = new Collisions_1.Collisions();
    this.color = new AnimatableColor_1.AnimatableColor();
    this.life = new Life_1.Life();
    this.links = new Links_1.Links();
    this.move = new Move_1.Move();
    this.number = new ParticlesNumber_1.ParticlesNumber();
    this.opacity = new Opacity_1.Opacity();
    this.reduceDuplicates = false;
    this.rotate = new Rotate_1.Rotate();
    this.shadow = new Shadow_1.Shadow();
    this.shape = new Shape_1.Shape();
    this.size = new Size_1.Size();
    this.stroke = new Stroke_1.Stroke();
    this.twinkle = new Twinkle_1.Twinkle();
  }

  _createClass(Particles, [{
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d, _e, _f, _g;

      if (data === undefined) {
        return;
      }

      this.bounce.load(data.bounce);
      this.color = AnimatableColor_1.AnimatableColor.create(this.color, data.color);
      this.life.load(data.life);
      var links = (_b = (_a = data.links) !== null && _a !== void 0 ? _a : data.lineLinked) !== null && _b !== void 0 ? _b : data.line_linked;

      if (links !== undefined) {
        this.links.load(links);
      }

      this.move.load(data.move);
      this.number.load(data.number);
      this.opacity.load(data.opacity);

      if (data.reduceDuplicates !== undefined) {
        this.reduceDuplicates = data.reduceDuplicates;
      }

      this.rotate.load(data.rotate);
      this.shape.load(data.shape);
      this.size.load(data.size);
      this.shadow.load(data.shadow);
      this.twinkle.load(data.twinkle);
      var collisions = (_d = (_c = data.move) === null || _c === void 0 ? void 0 : _c.collisions) !== null && _d !== void 0 ? _d : (_e = data.move) === null || _e === void 0 ? void 0 : _e.bounce;

      if (collisions !== undefined) {
        this.collisions.enable = collisions;
      }

      this.collisions.load(data.collisions);
      var strokeToLoad = (_f = data.stroke) !== null && _f !== void 0 ? _f : (_g = data.shape) === null || _g === void 0 ? void 0 : _g.stroke;

      if (strokeToLoad === undefined) {
        return;
      }

      if (strokeToLoad instanceof Array) {
        this.stroke = strokeToLoad.map(function (s) {
          var tmp = new Stroke_1.Stroke();
          tmp.load(s);
          return tmp;
        });
      } else {
        if (this.stroke instanceof Array) {
          this.stroke = new Stroke_1.Stroke();
        }

        this.stroke.load(strokeToLoad);
      }
    }
  }, {
    key: "line_linked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "lineLinked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }]);

  return Particles;
}();

exports.Particles = Particles;